var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-end": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800px" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "AdministrationEditUserDetailDialog.editTitleMsg"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.clearForm()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "form",
                  staticStyle: { width: "100%" },
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function ($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { "pa-5": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Email",
                                  rules: _vm.emailRules,
                                },
                                model: {
                                  value: _vm.editUserData.Email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editUserData, "Email", $$v)
                                  },
                                  expression: "editUserData.Email",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Tenant",
                                  items: _vm.activeTenantNames,
                                  rules: [(v) => !!v || "Tenant is required"],
                                  required: "",
                                },
                                model: {
                                  value: _vm.editUserData.UserRole,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editUserData, "UserRole", $$v)
                                  },
                                  expression: "editUserData.UserRole",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                attrs: { label: "Is System Administrator" },
                                model: {
                                  value: _vm.editUserData.IsSysAdmin,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editUserData,
                                      "IsSysAdmin",
                                      $$v
                                    )
                                  },
                                  expression: "editUserData.IsSysAdmin",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                attrs: { label: "Is Tenant Administrator" },
                                model: {
                                  value: _vm.editUserData.IsTenantAdmin,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editUserData,
                                      "IsTenantAdmin",
                                      $$v
                                    )
                                  },
                                  expression: "editUserData.IsTenantAdmin",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-switch", {
                                attrs: {
                                  label: "Enable Two factor authentication",
                                },
                                model: {
                                  value: _vm.editUserData.EnableTwoFactor,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editUserData,
                                      "EnableTwoFactor",
                                      $$v
                                    )
                                  },
                                  expression: "editUserData.EnableTwoFactor",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "success",
                            disabled: _vm.saveDisable,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.submit()
                            },
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("done"),
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Button.Save")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary", outline: "" },
                          on: {
                            click: function ($event) {
                              return _vm.clearForm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { color: "grey lighten-4" } },
        [
          _c(
            "v-snackbar",
            {
              staticStyle: { "text-align": "center" },
              attrs: { color: _vm.snackColor, timeout: null, top: "" },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }